module.exports = __webpack_public_path__ + "static/pilbara-solar-reversed-ace7190ae612f93d4671275f674fde45.png";